import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/api";

import { SharedService } from "../../service/api/shared.service";

@Component({
  selector: "app-find-existing-visitor",
  templateUrl: "./find-existing-visitor.component.html",
  styleUrls: ["./find-existing-visitor.component.scss"],
})
export class FindExistingVisitorComponent implements OnInit {
  visitorInfo: any;
  visitorData: any;
  tableFlag: boolean = false;
  userInfo: any;

  constructor(private service: SharedService, public ref: DynamicDialogRef) {}

  SearchVisitor() {
    this.service.searchVisitor(this.visitorInfo).subscribe(
      (resp) => {
        this.visitorData = resp;
        if (this.visitorData != null) {
          if (this.visitorData.length != 0) {
            this.tableFlag = true;
          }
        }
      },
      (error) => {}
    );
  }
  clearSearch() {
    this.tableFlag = false;
  }

  setVistor(visitorData) {
    this.ref.close(visitorData);
  }

  closePopUp() {
    this.ref.close();
  }
  ngOnInit() {}
}
